const INTUIT_APIKEY = window.__shellInternal?.appExperience?.appApiKey || '';

export const APP_FABRIC_CONFIG = {
  proxyBaseUrl: 'https://mc-appfabricproxy-e2e.api.intuit.com',
  proxyDefaultOptions: {
    mode: 'cors',
    credentials: 'include',
    redirect: 'follow',
  },

  // Dynamic values needed for request headers for Proxy
  intuit_apikey: INTUIT_APIKEY,
  intuit_userid:
    window.__shellInternal?.applicationContext?.userAuthInfo?.authId || '',
  authorization_header_value: `Intuit_APIKey intuit_apikey=${INTUIT_APIKEY}, intuit_apikey_version=1.0`,
  incoming_host: 'mc-appfabricproxy-e2e.api.intuit.com',
} as const;
